import React, { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line import/named
import { v4 as generateUUIDV4 } from 'uuid';
import { getNewToken, isTokenValid } from '@/authentication/api';
import { AuthenticatedUserModel } from '@/authentication/models';

export const TOKEN_PROP_NAME: string = 'auth-token';

type UseAuthorizationParams = {
    storeAuthenticatedUser: (authenticatedUser: AuthenticatedUserModel) => void;
};

export const useAuthorization = ({ storeAuthenticatedUser }: UseAuthorizationParams) => {
    const [loading, setLoading] = useState<boolean>(true);

    const processCreationOfToken = useCallback(async (contactId: string) => {
        setLoading(true);
        const newToken = await getNewToken(contactId, generateUUIDV4());
        localStorage.setItem(TOKEN_PROP_NAME, newToken);
        checkTokenValidity();
    }, []);

    const checkTokenValidity = useCallback(async (): Promise<void> => {
        try {
            const authenticatedUser = await isTokenValid();
            storeAuthenticatedUser(authenticatedUser);
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    }, [storeAuthenticatedUser]);

    const getToken = useCallback((): string | null => {
        return localStorage.getItem(TOKEN_PROP_NAME);
    }, []);

    const clearToken = useCallback(() => {
        localStorage.removeItem(TOKEN_PROP_NAME);
    }, []);

    useEffect(() => {
        const token: string | null = localStorage.getItem(TOKEN_PROP_NAME);

        if (token !== null) {
            checkTokenValidity();
        } else {
            setLoading(false);
        }
    }, []);

    return {
        isLoadingAuthentication: loading,
        processCreationOfToken,
        getToken,
        clearToken,
    };
};
